import DeudaForm from './DeudaForm'
export {DeudaForm}
export default DeudaForm
